export const APP_DESCRIPTION = 'Portal';
export const CONTACTS_FILTER_APPLIED = 'contacts-filter-applied';
export const CONTACTS_USER_CLICKED = 'contacts-user-clicked';
export const CONTACTS_USER_OPENED = 'contacts-user-opened';
export const CONTACTS_USER_INFO_EDITED = 'contacts-user-info-edited';
export const CONTACTS_REFRESHED = 'contacts-refreshed';
export const ANALYTICS_CONTACTS_DATE_CHANGED = 'analytics-contacts-date-changed';
export const CONTACTS_USER_REFRESHED = 'contacts-user-refreshed';
export const CONTACTS_USER_TICKET_OPENED = 'contacts-user-ticket-opened';
export const CONTACTS_USER_TICKET_HISTORY_NOT_FOUND_THREAD = 'helpdesk-ticket-history-not-found-on-thread';
export const CONTACTS_USER_TICKET_HISTORY_EXPORTED = 'helpdesk-ticket-history-thread-exported';
export const CONTACTS_USER_TICKET_HISTORY_COPIED = 'desk-ticket-history-thread-copied';
export const CONTACTS_USER_TEST_TOGGLE = 'contacts-user-test-toggle';
export const TICKET_LINKED = 'ticket-linked';
export const TICKET_UNLINKED = 'ticket-unlinked';
export const TICKET_LINK_MODAL_OPEN = 'ticket-link-modal-open';
export const TICKET_HISTORY_THREAD_VIEWED = 'ticket-history-thread-viewed';
export const TICKET_HISTORY_DETAILS_EXPANDED = 'ticket-history-details-expanded';
